module.exports = __webpack_public_path__ + "static/media/logo-carnaval.fb8ff9c4.svg";